<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Template" ripple class="secondary-tab">
			Template
		</v-tab>
		<v-tab key="Stampa" ripple class="secondary-tab">
			Stampa
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="background-1 pt-3 pb-1" key="Campi">
			<v-row class="ma-0">

				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector
						model-def="ddt"
						:totals="[{ label: 'Totali DDT', infoTotals: 'info_totals' }]"
					></fields-selector>
				</v-col>

				<!-- DDT Ticket -->
				<v-col class="pa-0 pt-4" cols="12" v-if="$store.getters.checkModulePermissions('tickets')">
					<fields-selector
						model-def="ddt"
						template-data="template_data_ticket_ddt"
						info="info_ticket_ddt"
					></fields-selector>
				</v-col>

			</v-row>
			<v-tabs
				class="tabs-pill mt-4"
				height="34"
				background-color="background-1"
				slider-color="primary">
				<v-tab key="Campi" ripple class="secondary-tab">
					Campi
				</v-tab>

				<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
					<v-row class="ma-0 pb-offset">

						<v-col class="pa-0 pt-2" cols="12">
							<fields-selector
								model-def="ddtproduct"
								audit
							></fields-selector>
						</v-col>

						<!-- Prodotti DDT Ticket -->
						<v-col class="pa-0 pt-4" cols="12" v-if="$store.getters.checkModulePermissions('tickets')">
							<fields-selector
								model-def="ddtproduct"
								template-data="template_data_ticket_ddt"
								info="info_ticket_ddt"
								audit
							></fields-selector>
						</v-col>

					</v-row>
				</v-tab-item>

			</v-tabs>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="ddt"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Template">
			<v-row class="ma-0">
				<v-col class="pa-0" cols="12">
					<crud
						model-def="templates-ddt"
						action-icon="dynamic_feed"
						title="Template DDT di vendita"
						action-position='absolute'>
					</crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-1" key="Stampa">
			<v-row class="ma-0">
				<ddts-print></ddts-print>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Altro">
			<v-row class="ma-0">
				<ddts-other></ddts-other>
			</v-row>
		</v-tab-item>
	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import DdtsPrint from '@/components/modules/ddts/settings/DdtsPrint'
import DdtsOther from '@/components/modules/ddts/settings/DdtsOther'

	export default {
		name:'ddts-settings',
        components: {
			DdtsPrint,
            DdtsOther,
			FieldsSelector,
			ActionsSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
